import { GTCouponStatus } from 'gql/types.generated'
import { defineMessages } from 'react-intl'

export const couponStatusMessages: Record<
  GTCouponStatus,
  {
    id: string
    defaultMessage: string
  }
> = defineMessages({
  [GTCouponStatus.Created]: {
    id: 'trip.incidenceCoupons.list.couponStatus.created',
    defaultMessage: 'Created'
  },
  [GTCouponStatus.Redeemed]: {
    id: 'trip.incidenceCoupons.list.couponStatus.redeemed',
    defaultMessage: 'Redeemed'
  },
  [GTCouponStatus.Sent]: {
    id: 'trip.incidenceCoupons.list.couponStatus.sent',
    defaultMessage: 'Sent'
  },
  [GTCouponStatus.Expired]: {
    id: 'trip.incidenceCoupons.list.couponStatus.expired',
    defaultMessage: 'Expired'
  }
})
